import React, {useEffect} from "react";
import "./TeacherPage.sass"
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router";
import {getAllCommonTeachers} from "../../../_actions/commonService";
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';
import {ADDRESS} from "../../../_api/client";
import Spinner from "./Spinner";
import CloseIcon from "@mui/icons-material/Close";
import CircleButton from "../../../_components/common/buttons/CircleButton";
import Window from "../../../_containers/window/Window";
import {IDLE, LOADING, SUCCESS} from "../../../common/statuses";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import _ from "lodash";
import {TEACHERS} from "../../../common/links";

export default function TeacherPage() {
    const {data, status} = useSelector(state => state.common.teachers)
    const params = useParams();
    const id = parseInt(params.id)
    const dispatch = useDispatch();

    useEffect(() => {
        if (status === IDLE) {
            dispatch(getAllCommonTeachers())
        }
        if (status === SUCCESS) {
            const t = data.filter(item => item.id === id)[0];
            document.title = `КьюАй - ${t.lastName} ${t.firstName}`;
        }
    }, [status, dispatch]);
    useEffect(() => {
        if (!_.isEmpty(data)) {
            const t = data.filter(item => item.id === id)[0];
            document.title = `КьюАй - ${t.lastName} ${t.firstName}`;
        } else {
            document.title = 'КьюАй - Загрузка...';
        }
    }, [])

    if (status === IDLE || status === LOADING) {
        return <Spinner/>
    }

    const teacher = data.filter(item => item.id === id)[0];
    const {firstName, lastName, middleName, courses, img, educations, description} = teacher;

    return (
        <Window>
            <div className="teacher-page-person-info-wrapper">
                <div className="teacher-page-person-info-img-wrapper teacher-page-full">
                    <img src={`${ADDRESS}/avatar/${img}`} alt="Ваше фото"/>
                </div>
                <div className="teacher-page-person-info-text-wrapper">
                    <div className="teacher-page-person-info-text">
                        <div className="teacher-page-person-info-text-username">
                            {`${lastName} ${firstName}`} { middleName && middleName}
                        </div>
                        <div className="teacher-page-person-info-setting">
                            <CircleButton Icon={CloseIcon} link={TEACHERS}/>
                        </div>
                    </div>
                    <div className="teacher-page-person-info-img-wrapper teacher-page-phone">
                        <img src={`${ADDRESS}/avatar/${img}`} alt="Ваше фото"/>
                    </div>
                    <div className="teacher-page-person-info-text-courses-time-wrapper">
                        <div className="teacher-page-person-info-text-courses-time">
                            <div className="teacher-page-person-info-text-courses-time-icon">
                                <WorkspacePremiumOutlinedIcon/>
                            </div>
                            <div className="teacher-page-person-info-text-courses-time-text">
                                <div><b>Образование:</b></div>
                                <div>
                                    {
                                        educations && educations.map(e =>
                                            <div key={`educations-${e.id}`}>{`${e.university}, ${e.specialization}`}</div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="teacher-page-person-info-text-courses-time">
                            <div className="teacher-page-person-info-text-courses-time-icon">
                                <SchoolOutlinedIcon/>
                            </div>
                            <div className="teacher-page-person-info-text-courses-time-text">
                                <div><b>Ведет курсы:</b></div>
                                <div>
                                    {
                                        courses && courses.map(course => course.name).join(', ')
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="teacher-page-about" dangerouslySetInnerHTML={{__html: description}}>

            </div>
        </Window>
    )
}
